import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { message } from "antd";
import LoaderSpin from "../../Commons/LoaderSpin";
import ControlPointSharpIcon from "@mui/icons-material/ControlPointSharp";
import ArrowDropDownOutlinedIcon from "@mui/icons-material/ArrowDropDownOutlined";
import EmailPreview from "../SendInvoice/EmailPreview";
import DoneModal from "../SendInvoice/DoneModal";

import TextStyles from "../../../../Constants/TextStyles";
import Styled from "../SendInvoice/SendInvoiceStyles";
import { ReactTooltip } from "../../Commons/ReactTooltip";

import { Popover } from "antd";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AddTemplateModal from "../SendInvoice/AddTemplateModal";
import AddContactModal from "../SendInvoice/AddContactModal";
import Colors from "../../../../Constants/Colors";
import { resendInvoice } from "../../../../store/service/invoiceService";
import { invoiceActions } from "../../../../store/storage/invoiceSlice";
import CheckCircleSharpIcon from "@mui/icons-material/CheckCircleSharp";
import moment from "moment";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { useAllowedToContinue } from "../../../../hooks/useAllowedToContinue";

const SendInvoice = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.invoices.isLoading);
  const selectedInvoiceData = useSelector(
    (state) => state.invoices.selectedInvoiceData
  );

  const data = useSelector((state) => state.auth.data);
  const templateData = useSelector((state) => state.auth.templateData);

  const businessInfoData = useSelector((state) => state.auth.businessInfoData);
  const brandAndLogoData = useSelector((state) => state.auth.brandAndLogoData);

  const [addContactModal, setAddContactModal] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [showDoneModal, setShowDoneModal] = useState(false);

  const contacts =
    selectedInvoiceData && selectedInvoiceData.client_id
      ? selectedInvoiceData.client_id.contacts
      : [];

  const primaryContactName =
    contacts && contacts.filter((contact) => !contact.isNotselected)[0];

  // template
  const [openTemplate, setOpenTemplate] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState("Default");
  const [addTemplateModal, setAddTemplateModal] = useState(false);

  const isContactAllowed = useAllowedToContinue("contactsToEmail");
  const isSentAllowed = useAllowedToContinue("invoiceSentCount");

  const hideTemplateHandler = () => {
    setOpenTemplate(false);
  };
  const handleOpenTemplateChange = (newOpen) => {
    setOpenTemplate(newOpen);
  };

  const removeContact = (index) => {
    const newContacts =
      contacts &&
      contacts.map((contact, i) =>
        i === index
          ? {
              ...contact,
              isNotselected: !contact.isNotselected,
            }
          : contact
      );

    const clientData = selectedInvoiceData &&
      selectedInvoiceData.client_id && {
        ...selectedInvoiceData.client_id,
        contacts: newContacts,
      };
    dispatch(invoiceActions.selectedInvoiceAction({ client_id: clientData }));
  };

  const subjectData = `${
    selectedInvoiceData && selectedInvoiceData.invoice_title
  } from ${
    businessInfoData && businessInfoData.business_name
      ? businessInfoData.business_name
      : `${data.firstName} ${data.lastName}`
  }`;

  const [subject, setSubject] = useState(subjectData);

  const textData = `Hi ${
    primaryContactName ? primaryContactName.contact_name : ""
  },\n\nI hope this message finds you well.\n This is a friendly reminder that Invoice ${
    selectedInvoiceData && selectedInvoiceData.invoice_no
  }, dated ${
    selectedInvoiceData &&
    selectedInvoiceData.issued &&
    moment(selectedInvoiceData.issued).format("DD MMM YYYY")
  }, for the amount of ${
    selectedInvoiceData &&
    selectedInvoiceData.currency &&
    selectedInvoiceData.currency.symbol
  }${
    selectedInvoiceData && selectedInvoiceData.invoiced_amount
      ? parseFloat(selectedInvoiceData.invoiced_amount).toFixed(2)
      : "00:00"
  } is currently due. The payment was expected by ${
    selectedInvoiceData &&
    selectedInvoiceData.due_date &&
    moment(selectedInvoiceData.due_date).format("DD MMM YYYY")
  }.\n\nPlease let me know if there are any issues or if further details are required to process the payment. I'd be happy to assist.
I kindly request that payment be made at your earliest convenience.\n\nThank you for your prompt attention to this matter.\n\nBest regards,\n${
    businessInfoData && businessInfoData.business_name
      ? businessInfoData.business_name
      : `${data.firstName} ${data.lastName}`
  }`;

  const [text, setText] = useState(textData);

  const { register, reset, watch, handleSubmit } = useForm({
    defaultValues: {
      email_subject: subjectData,
      email_text: textData,
    },
  });

  useEffect(() => {
    if (selectedTemplate === "Default") reset({ email_text: textData });
  }, [primaryContactName]);

  const revisedSubject = watch("email_subject");
  const revisedText = watch("email_text");

  useEffect(() => {
    setSubject(revisedSubject);
  }, [revisedSubject]);

  useEffect(() => {
    setText(revisedText);
  }, [revisedText]);

  useEffect(() => {
    if (selectedTemplate !== "Default") {
      const filteredTemplate =
        templateData &&
        templateData.filter(
          (item) => item.template_name === selectedTemplate
        )[0];

      setSubject(filteredTemplate.template_subject);
      setText(filteredTemplate.template_message);
      reset({
        email_subject: filteredTemplate.template_subject,
        email_text: filteredTemplate.template_message,
      });
    } else {
      setSubject(subjectData);
      setText(textData);
      reset({
        email_subject: subjectData,
        email_text: textData,
      });
    }
  }, [selectedTemplate]);

  const formsubmit = (item) => {
    const Obj = {
      _id: selectedInvoiceData && selectedInvoiceData._id,
      client_id:
        selectedInvoiceData &&
        selectedInvoiceData.client_id &&
        selectedInvoiceData.client_id._id,
      contacts:
        selectedInvoiceData &&
        selectedInvoiceData.client_id &&
        selectedInvoiceData.client_id.contacts &&
        selectedInvoiceData.client_id.contacts.filter((item) => !item._id),
      send_email: {
        email_subject: item.email_subject,
        email_text: item.email_text,
        email_template: selectedTemplate,
        emails_sent_to: contacts
          .filter((item) => !item.isNotselected)
          .map((d) => {
            return { email: d.email };
          }),
      },
    };

    dispatch(resendInvoice(Obj)).then((data) => {
      if (data.meta.requestStatus === "fulfilled") {
        setShowDoneModal(true);
      } else {
        message.error(`${data.error.message}!`);
      }
    });
  };

  const templateContent = () => {
    return (
      <div>
        <TextStyles.FontSize14px
          style={{
            maxHeight: 240,
            width: 260,
            overflowY: "scroll",
            position: "relative",
          }}
        >
          <Styled.TemplateLi
            onClick={() => {
              setSelectedTemplate("Default");
              hideTemplateHandler();
            }}
          >
            <ArrowRightIcon sx={{ fontSize: 24, color: Colors.font2 }} />
            Default
          </Styled.TemplateLi>
          {templateData &&
            templateData.map((item, index) => {
              return (
                <Styled.TemplateLi
                  key={index}
                  onClick={() => {
                    setSelectedTemplate(item.template_name);
                    hideTemplateHandler();
                  }}
                  style={{ minWidth: "4rem" }}
                >
                  <ArrowRightIcon sx={{ fontSize: 24, color: Colors.font2 }} />
                  <span className="three-dots"> {item.template_name}</span>
                </Styled.TemplateLi>
              );
            })}
        </TextStyles.FontSize14px>
        <div
          className="my-2"
          style={{
            width: "100%",
            height: "1px",
            border: "0.5px solid #efefef",
          }}
        />
        <Styled.TemplateLi
          style={{ position: "sticy", bottom: 0, zIndex: 20 }}
          className="d-flex ps-2"
          onClick={() => {
            setAddTemplateModal(true);
            hideTemplateHandler();
          }}
        >
          <AddCircleIcon sx={{ fontSize: 16, color: Colors.primary }} />
          <span
            className="ms-1"
            style={{
              color: Colors.primary,
              fontWeight: 500,
              // textDecoration: "1px solid underline",
            }}
          >
            New template
          </span>
        </Styled.TemplateLi>
      </div>
    );
  };

  return (
    <div className="px-lg-4 px-md-4 px-sm-3 px-2">
      <div
        className="d-flex justify-content-center w-100"
        style={{ contain: "content" }}
      >
        <div style={{ width: "100%", maxWidth: 650 }}>
          <TextStyles.FontSize22px className="text-center font-weight-500 mb-4">
            Compose email
          </TextStyles.FontSize22px>
          <Styled.SendBox>
            <TextStyles.FontSize14px className="mb-2">
              To
            </TextStyles.FontSize14px>

            <div className="d-flex gap-2 justify-content-between align-items-center">
              <Styled.ChipsRectangle>
                {contacts &&
                  contacts.map((item, index) => {
                    return (
                      <div key={index}>
                        <ReactTooltip
                          anchorId={`contacts${index}`}
                          content={`${
                            item.isNotselected ? "Add:" : "Remove:"
                          } ${item.email}`}
                          variant={"brandColor"}
                          color={Colors.white}
                        />
                        <Styled.ChipRectangle
                          selected={
                            item.isNotselected ? item.isNotselected : false
                          }
                          id={`contacts${index}`}
                          onClick={() => removeContact(index)}
                        >
                          <CheckCircleSharpIcon
                            sx={{
                              fontSize: 18,
                              color: !item.isNotselected
                                ? Colors.primary
                                : Colors.font2,
                            }}
                          />

                          <TextStyles.FontSize14px
                            className="d-inline-block ms-2"
                            style={{
                              color: !item.isNotselected
                                ? Colors.primary
                                : Colors.font1,
                            }}
                          >
                            {item.contact_name}
                          </TextStyles.FontSize14px>
                        </Styled.ChipRectangle>
                      </div>
                    );
                  })}
              </Styled.ChipsRectangle>

              {!isContactAllowed && <ReactTooltip anchorId='invoice-contact' content='Upgrade Plan' variant='grey' />}
              <ControlPointSharpIcon
                id='invoice-contact'
                className={isContactAllowed ? '' : 'opacity-75'}
                onClick={() => isContactAllowed ? setAddContactModal(true) : {}}
                sx={{ color: Colors.font1, fontSize: 24, cursor: "pointer" }}
              />
            </div>
          </Styled.SendBox>
          <form onSubmit={handleSubmit(formsubmit)}>
            <Styled.SendBox className="my-4">
              <div className="d-flex flex-wrap flex-sm-nowrap gap-3 justify-content-between">
                <TextStyles.FontSize14px className="w-100">
                  <TextStyles.InputRectangle
                    placeholder="Subject"
                    // defaultValue={subject}
                    name="email_subject"
                    {...register(`email_subject`, {
                      required: "Subject can't be empty.",
                      validate: (value) => {
                        let trimedLength = value.trim().length;
                        if (trimedLength === 0) {
                          return "Subject can't be empty.";
                        }
                        return true;
                      },
                    })}
                  />
                </TextStyles.FontSize14px>
                <div
                  className="w-100"
                  style={{ maxWidth: "7.5rem", marginLeft: "auto" }}
                >
                  <Styled.Template>
                    <Popover
                      placement="bottomRight"
                      zIndexPopup={150}
                      // title={"Hello"}
                      content={templateContent}
                      trigger="click"
                      open={openTemplate}
                      onOpenChange={handleOpenTemplateChange}
                      className="email-template-popover"
                    >
                      <TextStyles.FontSize14px
                        style={{
                          cursor: "pointer",
                          color: Colors.primary,
                          fontWeight: 500,
                          width: "100%",
                          height: "100%",
                          padding: "0 15px 0 20px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div
                          className="three-dots"
                          style={{
                            width: "6rem",
                          }}
                        >
                          {selectedTemplate}
                        </div>
                        <ArrowDropDownOutlinedIcon
                          sx={{
                            color: Colors.primary,
                            fontSize: 27,
                            transform: openTemplate ? "rotate(180deg)" : "",
                          }}
                        />
                      </TextStyles.FontSize14px>
                    </Popover>
                  </Styled.Template>
                </div>
              </div>
              <TextStyles.FontSize14px className="mt-4">
                <TextStyles.Textarea
                  className="textarea_padding_right"
                  rows={10}
                  placeholder="Add Text..."
                  name="email_text"
                  {...register(`email_text`, {
                    required: "Email text can't be empty.",
                    validate: (value) => {
                      let trimedLength = value.trim().length;
                      if (trimedLength === 0) {
                        return "Email text can't be empty.";
                      }
                      return true;
                    },
                  })}
                />
              </TextStyles.FontSize14px>
            </Styled.SendBox>
            <div className="pb-3">
              <div className="d-flex gap-3 justify-content-between">
                <TextStyles.CancelButton
                  onClick={() => setShowPreviewModal(true)}
                >
                  Preview email
                </TextStyles.CancelButton>

                {!isSentAllowed && <ReactTooltip anchorId='send-invoice' content='Upgrade Plan' variant='grey' />}
                <TextStyles.Button
                  id='send-invoice'
                  disabled={
                    primaryContactName === undefined || isLoading || !isSentAllowed
                  }
                >
                  {isLoading && addContactModal === false ? (
                    <LoaderSpin />
                  ) : (
                    "Send"
                  )}
                </TextStyles.Button>
              </div>
            </div>
          </form>
        </div>
      </div>

      {showPreviewModal && (
        <EmailPreview
          show={showPreviewModal}
          handleClose={() => setShowPreviewModal(false)}
          data={data}
          businessInfoData={businessInfoData}
          selectedInvoiceData={selectedInvoiceData}
          subject={subject}
          text={text}
          brandAndLogoData={brandAndLogoData}
        />
      )}

      {addTemplateModal && (
        <AddTemplateModal
          show={addTemplateModal}
          handleClose={() => setAddTemplateModal(false)}
        />
      )}
      {addContactModal && (
        <AddContactModal
          show={addContactModal}
          handleClose={() => setAddContactModal(false)}
        />
      )}

      {showDoneModal && (
        <DoneModal
          show={showDoneModal}
          handleClose={() => setShowDoneModal(false)}
          data={data}
          selectedInvoiceData={selectedInvoiceData}
        />
      )}
    </div>
  );
};

export default SendInvoice;
